import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-secondary-100">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-9 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2 lg:pr-10">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-movie-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                甜蜜的惩罚
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-300">
              甜蜜的惩罚是面向影视剧爱好者的资讯与剧情介绍门户，覆盖电视剧、电影与网剧多类型作品，
              为您提供最新影视资讯、剧情概要及相关影视动态，帮助影迷快速发现感兴趣的内容。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-line", "ri-wechat-line", "ri-bilibili-line", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-800 text-lg text-secondary-200 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">
              影视频道
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link
                  to="/category/drama"
                  className="text-secondary-300 transition-colors hover:text-primary-300 cursor-pointer"
                >
                  电视剧
                </Link>
              </li>
              <li>
                <Link
                  to="/category/movie"
                  className="text-secondary-300 transition-colors hover:text-primary-300 cursor-pointer"
                >
                  电影
                </Link>
              </li>
              <li>
                <Link
                  to="/category/web"
                  className="text-secondary-300 transition-colors hover:text-primary-300 cursor-pointer"
                >
                  网剧
                </Link>
              </li>
              <li>
                <Link
                  to="/search"
                  className="text-secondary-300 transition-colors hover:text-primary-300 cursor-pointer"
                >
                  搜索影视
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">
              关于本站
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link
                  to="/about"
                  className="text-secondary-300 transition-colors hover:text-primary-300 cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-secondary-300 transition-colors hover:text-primary-300 cursor-pointer"
                >
                  最新资讯
                </Link>
              </li>
              <li className="text-secondary-300">
                联系邮箱：<span className="text-secondary-100">hello@tmcf-media.com</span>
              </li>
              <li className="text-secondary-300">合作洽谈：media@tmcf-media.com</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-secondary-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 甜蜜的惩罚 · 影视资讯与剧情介绍门户 · 内容仅供演示参考</p>
          <p className="flex flex-wrap gap-x-4 gap-y-1">
            <span>本站所有影视资料为演示数据</span>
            <span>不提供播放与下载服务</span>
          </p>
        </div>
      </div>
    </footer>
  );
}